/**
 * Словарь шумлянского для мини-игры Уфо («Расшифруй слова»).
 * Карточки без перевода в пул не входят.
 */

export type UfoDecipherCard = {
  phrase: string;
  meanings: readonly string[];
};

export type UfoDecipherRound = {
  phrase: string;
  options: readonly [string, string, string];
  correctIndex: 0 | 1 | 2;
};

export const UFO_DECIPHER_DICTIONARY: readonly UfoDecipherCard[] = [
  {
    phrase: 'Ти-ри-ри!',
    meanings: ['Привет', 'Здравствуйте', 'Пока!', 'До свидания!'],
  },
  { phrase: 'Исими-у', meanings: ['Пожалуйста!'] },
  { phrase: 'Ори-кори', meanings: ['Извините'] },
  { phrase: 'Пади баки', meanings: ['Помогите'] },
  {
    phrase: 'Миримиси',
    meanings: ['милый', 'любимый', 'хороший мой', 'хочу обнять'],
  },
  {
    phrase: 'Абосари моку',
    meanings: ['застрять', 'попасть в беду', 'вляпаться', 'облажаться'],
  },
  { phrase: 'Ото', meanings: ['Хотеть', 'Просить', 'Заказывать'] },
  { phrase: 'Отомо', meanings: ['заказ'] },
  { phrase: 'Лика', meanings: ['Будет сделано', 'выполню'] },
  { phrase: 'Тонк! Лирик тонк!', meanings: ['Стой!'] },
  { phrase: 'Малиса', meanings: ['Подожди', 'Не торопись'] },
  { phrase: 'Чеку-Чеку', meanings: ['Смотри'] },
  { phrase: 'Кири миши!', meanings: ['Ты всё испортил!'] },
  {
    phrase: 'Ари-пити!',
    meanings: ['Есть!', 'Сейчас!', 'Положитесь на меня!'],
  },
  {
    phrase: 'Та-ла-ла!',
    meanings: ['Эврика!', 'есть идея!', 'победа!', 'моя взяла!'],
  },
  {
    phrase: 'Капиду!',
    meanings: ['Не вешайте нос', 'не переживай'],
  },
  {
    phrase: 'Леми-и-баки',
    meanings: [
      'Я приведу помощь',
      'Я обращусь к народу',
      'Я возглавлю революцию',
    ],
  },
  {
    phrase: 'Дорика Тулими Тикапули!',
    meanings: [
      'Всё намного сложнее',
      'нет времени объяснять',
      'Я должна вам рассказать, ваши планы под угрозой',
      'с коллегами сложно договориться',
    ],
  },
  {
    phrase: 'Атапи!',
    meanings: ['опасность', 'внимание', 'важное объявление', 'все сюда'],
  },
  { phrase: 'Ми - пири капир!', meanings: ['Я - лучший курьер!'] },
  { phrase: 'Абире и табири!', meanings: ['Доставка и распаковка!'] },
  { phrase: 'Оби-соби', meanings: ['Растаяло'] },
  { phrase: 'Курентку', meanings: ['Конкурент'] },
  {
    phrase: 'матти кемири! Нагаре!',
    meanings: ['Он бы такого не сделал! Он не такой!'],
  },
  {
    phrase: 'Ари! Токо на соко намияни!',
    meanings: ['Ах! Он так красиво поет!'],
  },
  { phrase: 'Соби?', meanings: ['Кто здесь?'] },
  { phrase: 'Оуй!', meanings: ['Ой!'] },
  { phrase: 'Мелафони', meanings: ['Музыка'] },
  { phrase: 'Карам абире', meanings: ['Куда доставить?'] },
  { phrase: 'Финита!', meanings: ['Время вышло', 'Конец'] },
  { phrase: 'Лика!', meanings: ['Будет сделано!'] },
  { phrase: 'Рамитири-би саки', meanings: ['Надоело это'] },
  { phrase: 'Корли-дуно-пролине-пиу-пу', meanings: ['У меня мало заряда'] },
  {
    phrase: 'Тонино-нино! А-аа, Пенимори!',
    meanings: ['Кончился заряд!', 'Падаю в Пенное море!'],
  },
  { phrase: 'Шпуньк!', meanings: ['Все', 'ой', 'упс'] },
  { phrase: 'Нии', meanings: ['не'] },
  { phrase: 'Том-по!', meanings: ['Я справлюсь!'] },
  {
    phrase: 'Коро, идо!',
    meanings: [
      'Большое спасибо за помощь, друзья!',
      'Большое спасибо за помощь',
      'Друзья',
    ],
  },
  {
    phrase: 'А́ви - ру́ли-рули!',
    meanings: ['Они - крутые!', 'они', 'крутые'],
  },
  { phrase: 'ТарасИно КумитЭ', meanings: ['Я получила обновление!'] },
  {
    phrase: 'УницифАно КорИнтия',
    meanings: ['И теперь могу всех научить своему языку'],
  },
  {
    phrase: 'ТонИно-нИно, самарО',
    meanings: ['А еще родители разрешили взять одного друга в гости'],
  },
  { phrase: 'ТирлЕски дАо', meanings: ['После обеда - первый урок'] },
  { phrase: 'ТонинокУра бу', meanings: ['Я научу всех языковым лучом'] },
  {
    phrase: 'СарамАски но чИе',
    meanings: ['Теперь все друзья будут меня понимать'],
  },
  {
    phrase: 'Пау, тау, сау, вау',
    meanings: ['десять, девять, восемь, семь'],
  },
  {
    phrase: 'Нииии СарамАски но чИе?',
    meanings: ['Друзья не будут меня понимать?'],
  },
  { phrase: 'Мау, фау, рау', meanings: ['Три, два, один'] },
  { phrase: 'ТонИно-МорАто?', meanings: ['Понимаете меня?'] },
  { phrase: 'СинАр полярИдос?', meanings: ['Что я говорю?'] },
  {
    phrase: 'Сорнато-ичик?',
    meanings: ['Ты не говоришь по-шумлянски?'],
  },
  { phrase: 'ОкиромаИва-э!', meanings: ['Кажется,да!'] },
  {
    phrase: 'КупИро мамИто фрАске?',
    meanings: ['Что же мне теперь делать?'],
  },
  {
    phrase: 'Блог пурсИмка тутУри?',
    meanings: ['Как я теперь буду вести блог?'],
  },
  { phrase: 'АбИре Отомо?', meanings: ['А доставлять заказы?'] },
  {
    phrase: 'КАпум сИби турИльо!',
    meanings: ['Меня же никто не поймет!'],
  },
  { phrase: 'Пиу-маня!', meanings: ['Краб'] },
  { phrase: 'Манаре-синсону!', meanings: ['Я же говорила!'] },
  { phrase: 'Ото СлЕпа', meanings: ['Хочется спать'] },
  { phrase: 'Том-по рекОрду', meanings: ['Я поставила рекорд!'] },
  {
    phrase: 'Финита Балабла! Тама Физили!',
    meanings: ['Хватит болтать! Время тренировок!'],
  },
  { phrase: 'Ни СвитАру!', meanings: ['Никаких сладостей!'] },
  { phrase: 'УтютЮру дисапЕру!', meanings: ['Малыш пропал!'] },
  {
    phrase: 'Вонтама биками пири капир!',
    meanings: [
      'Я просто хотела вырасти, чтобы стать лучшим курьером.',
    ],
  },
  {
    phrase: 'Та-ла-ла! Ири ранду! Хани ири ранду!',
    meanings: ['Точно! Все вокруг! Увеличить все вокруг!'],
  },
];

function pickIndex(length: number, random: () => number): number {
  return Math.min(length - 1, Math.floor(random() * length));
}

function shuffleInPlace<T>(items: T[], random: () => number): T[] {
  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = pickIndex(i + 1, random);
    const tmp = items[i]!;
    items[i] = items[j]!;
    items[j] = tmp;
  }
  return items;
}

/** Каждое слово ответа с заглавной буквы. */
export function capitalizeUfoAnswer(text: string): string {
  return text.replace(/(^|\s)(\S)/g, (_, sep: string, ch: string) => {
    return `${sep}${ch.toLocaleUpperCase('ru-RU')}`;
  });
}

/**
 * Один раунд: шумлянская фраза + 3 русских варианта (один верный).
 */
export function createUfoDecipherRound(
  random: () => number = Math.random,
): UfoDecipherRound {
  const dict = UFO_DECIPHER_DICTIONARY;
  if (dict.length < 3) {
    throw new Error('UFO dictionary needs at least 3 cards');
  }

  const cardIndex = pickIndex(dict.length, random);
  const card = dict[cardIndex]!;
  const correct = capitalizeUfoAnswer(
    card.meanings[pickIndex(card.meanings.length, random)]!,
  );

  const distractors: string[] = [];
  const distractorPool = dict
    .map((c, i) => (i === cardIndex ? null : capitalizeUfoAnswer(c.meanings[0]!)))
    .filter((m): m is string => m != null && m !== correct);

  shuffleInPlace(distractorPool, random);
  for (const meaning of distractorPool) {
    if (distractors.length >= 2) {
      break;
    }
    if (!distractors.includes(meaning)) {
      distractors.push(meaning);
    }
  }

  while (distractors.length < 2) {
    distractors.push(capitalizeUfoAnswer(`вариант ${distractors.length + 1}`));
  }

  const options = shuffleInPlace([correct, distractors[0]!, distractors[1]!], random);
  const correctIndex = options.indexOf(correct) as 0 | 1 | 2;

  return {
    phrase: card.phrase,
    options: [options[0]!, options[1]!, options[2]!],
    correctIndex,
  };
}
